// Résolution du nom (et coordonnées) imprimé sur une attestation.
//
// Règle métier : PAR DÉFAUT, un contrat MONO-ENGIN porte l'attestation au nom de l'ASSURÉ
// (souscripteur). Une FLOTTE garde le comportement historique (conducteur habituel de l'engin, sinon
// propriétaire de l'engin, sinon souscripteur), car chaque engin peut avoir son conducteur.
//
// L'interrupteur de la modale d'impression peut FORCER le choix via `preferSouscripteur` :
//   - true  → assuré d'abord ;
//   - false → conducteur d'abord (utile pour imprimer au nom du conducteur habituel saisi).
// Quand `preferSouscripteur` est undefined/null, on applique le défaut (mono→assuré, flotte→conducteur).
export const resolveAttestationDriver = ({ contrat, engin, preferSouscripteur } = {}) => {
    const ch = engin?.conducteurHabituel;
    const ep = engin?.personne;
    const sous = contrat?.souscripteur;
    const monoEngin = (contrat?.engins?.length ?? 0) === 1;
    const assureFirst = (preferSouscripteur !== null && preferSouscripteur !== undefined)
        ? !!preferSouscripteur : monoEngin;
    const order = assureFirst ? [sous, ch, ep] : [ch, ep, sous];
    const val = (g) => order.reduce((acc, p) => acc || g(p), undefined);
    const nom = val((p) => p?.nom) || "";
    const prenom = val((p) => p?.prenom) || "";
    return {
        nom,
        prenom,
        nomComplet: `${nom}${prenom ? " " + prenom : ""}`.trim(),
        adresse: val((p) => p?.adresse) || "_",
        contact: val((p) => p?.contact?.[0]) || " ",
        profession: val((p) => p?.profession) || "_",
    };
};

// Un conducteur habituel « exploitable » existe-t-il, ET est-il DIFFÉRENT de l'assuré ? Sert à n'afficher
// l'interrupteur « imprimer au nom du conducteur » que quand ça a du sens.
export const aConducteurDifferent = (contrat, engin) => {
    const ch = engin?.conducteurHabituel;
    const sous = contrat?.souscripteur;
    if (!ch || !ch.nom) return false;
    const norm = (s) => `${s || ""}`.trim().toLowerCase();
    return norm(ch.nom) !== norm(sous?.nom) || norm(ch.prenom) !== norm(sous?.prenom);
};
